import Check from "./Check";
import Cookies from "./Cookie";
import Axios from "axios";

var csrftoken = Cookies.get('csrfToken');
// let instance = csrftoken ? Axios.create({
//     timeout: 30000,
//     headers: { 'x-csrf-token': csrftoken }
// }) : Axios;
let instance = Axios;

// window._event.on(() => {
//     var csrftoken = Cookies.get('csrfToken');
//     console.log(csrftoken)
//     if (csrftoken) instance = Axios.create({
//         timeout: 10000,
//         headers: { 'x-csrf-token': csrftoken }
//     });
// }, "init_csrf");

const getUrl = ({ url, params }) => {
    // 过滤空属性
    if (typeof params === "object") Object.keys(params).forEach(key => {
        if ((!params[key] && ![0, "0"].includes(params[key])) || (typeof params[key] === "string" ? Check.isAllSpace(params[key]) : false)) delete params[key];
    })
    const p = url.indexOf("?") !== -1 ? "&" : "?";
    params = params
        ? Object.keys(params).map(val => `${val}=${typeof params[val] === "object" ? JSON.stringify(params[val]) : params[val]}`)
        : "";
    return encodeURI(
        url +
        `${p}${params ? params.join("&") + "&" : ""}_=${new Date().getTime()}`
    );
};

export default {
    get: async ({ url, params }) => {
        return await instance.get(getUrl({ url, params }));
    },
    delete: async ({ url, params }) => {
        return await instance.delete(getUrl({ url, params }));
    },
    post: async ({ url, params }) => {
        return await instance.post(url, params, {});
    },
    put: async ({ url, params }) => {
        return await instance.put(url, params);
    },
}